module.exports = JBrowseExports["@jbrowse/core/pluggableElementTypes/DisplayType"];